import { useEffect } from 'react';
import { ButtonDialog } from '@autopass-web/mochi-component';
import { analytics } from '../../app-loader';
import useAppStore from '../../app-store';

const BarcodePaymentDialog = ({ data, setData }) => {
  const appStore = useAppStore();

  useEffect(() => {
    if (data !== null) {
      analytics.barcode_payment_dialog_pageview({ type: data.type });
    }
  }, [data]);

  if (!data) return <></>;

  const dialogContent = (type) => {
    switch (type) {
      case 'popup_board':
        return {
          title: data.title,
          message: data.content,
          buttonList: [
            {
              theme: 'positive',
              content: data.buttonText,
              onClick: () => {
                setData(null);
              },
            },
          ],
        };
      case 'hint_board':
        return {
          image: data.image,
          title: data.title,
          message: data.content,
          buttonList: data.buttons.map((item) => {
            return {
              theme: item.theme,
              content: item.content,
              onClick: () => {
                if (item.theme === 'positive' && data.action)
                  return data.action();
                setData(null);
              },
            };
          }),
        };
      case 'no_payment':
        return {
          title: '條碼讀取失敗',
          message: data.content,
          buttonList: [
            {
              theme: 'positive',
              content: '關閉',
              onClick: () => {
                analytics.barcode_payment_dialog_onClick({ type });
                appStore.globalAction.backToMain();
                setData(null);
              },
            },
          ],
        };
      case 'fetch_fail':
        return {
          title: '條碼讀取失敗',
          message: data.content,
          buttonList: [
            {
              theme: 'positive',
              content: '關閉',
              onClick: () => {
                analytics.barcode_payment_dialog_onClick({ type });
                appStore.globalAction.backToMain();
                setData(null);
              },
            },
          ],
        };
      case 'payment_timeout':
        return {
          title: '交易逾時',
          message: '交易結果以現場 POS 機為主，請與站員確認。',
          buttonList: [
            {
              theme: 'positive',
              content: '關閉',
              onClick: () => {
                analytics.barcode_payment_dialog_onClick({ type });
                setData(null);
                appStore.globalAction.backToMain();
              },
            },
          ],
        };
      case 'payment_fail':
        return {
          title: '交易失敗',
          message:
            data.content ||
            '付款卡片交易授權失敗。請前往「付款方式」頁，更新綁定設定後重試。',
          buttonList: [
            {
              theme: 'positive',
              content: '關閉',
              onClick: () => {
                analytics.barcode_payment_dialog_onClick({ type });
                setData(null);
                appStore.globalAction.backToMain();
              },
            },
          ],
        };
      default:
        return '';
    }
  };

  const dialogData = dialogContent(data.type);

  if (!dialogData) return;

  return (
    <ButtonDialog
      title={dialogData.title}
      message={dialogData.message}
      buttonList={dialogData.buttonList}
      show={true}
    />
  );
};

export default BarcodePaymentDialog;
